export type Locale = "en" | "ru" | "kz" | "uz";
export const DEFAULT_LOCALE = "en";
